webpackJsonp([43],{

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("3f3fe4b2", content, true, {});

/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.content-buttons[data-v-78153a33]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/build/repo/src/pages/configuration/page-template.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,kCAAkC,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CACzJ","file":"page-template.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.content-buttons[data-v-78153a33]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dealers-projects"},[_c('action-sidebar',{attrs:{"title":"Template","value":true,"width":644},on:{"close-modal":_vm.closeModal}},[_c('v-tabs',{attrs:{"right":"","slider-color":"cyan"},model:{value:(_vm.tabsModel),callback:function ($$v) {_vm.tabsModel=$$v},expression:"tabsModel"}},[_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index},[_vm._v("\n\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t")])}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"selectable":"","name":"template","last-page":_vm.lastPage,"columns":_vm.columns,"rows":_vm.template,"check-all":_vm.checkAll,"selected-value":_vm.selectedValue,"current-page":_vm.currentPage},on:{"on-selected-all":_vm.allIsSelected,"on-search-event":_vm.onSearch,"row-is-selected":_vm.rowIsSelected,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t\t\t\t\t")])]}}])})],1),_vm._v(" "),_c('v-tab-item',[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"selectable":"","selected-value":_vm.selectedValueAssigned,"check-all":_vm.checkAllDeallocate,"columns":_vm.columns,"rows":_vm.templateAssigned,"current-page":_vm.currentPageDeallocate,"last-page":_vm.lastPageDeallocated},on:{"on-selected-all":_vm.allIsSelectedDeallocate,"on-search-event":_vm.onSearchTemplateDeallocate,"row-is-selected":_vm.rowIsSelectedDeallocate,"on-page":_vm.changePageDeallocate},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t\t\t\t\t")])]}}])})],1)],1)],2),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer pt-3 pb-3 content-buttons"},[_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"pink"},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\tCancelar\n\t\t\t\t"),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"18"}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-1",attrs:{"color":"success","disabled":_vm.disabledAssigned(1)},on:{"click":_vm.assignedTemplate}},[_vm._v("\n\t\t\t\tAsignar\n\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-2",attrs:{"color":"success","disabled":_vm.disabledDeallocated(0)},on:{"click":_vm.deleteTemplate}},[_vm._v("\n\t\t\t\tDesasignar\n\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_vue__ = __webpack_require__(841);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78153a33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_vue__ = __webpack_require__(1058);
function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78153a33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78153a33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function onSearch(value) {
	this.$emit('on-search', value);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dealers-list',
	methods: {
		allIsSelected: allIsSelected,
		changePage: changePage,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		rows: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		lastPage: {
			type: Number,
			default: 0
		},
		currentPage: {
			type: Number,
			default: 0
		},
		columns: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		checkAll: {
			type: Boolean,
			required: true
		},
		selectedValue: {
			type: String,
			required: true
		}
	}
});

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_assign_vue__ = __webpack_require__(614);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba25164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_assign_vue__ = __webpack_require__(660);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_assign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba25164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_assign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1"},[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"name":"dealers","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"selectable":""},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.codeProject)+"\n\t\t\t")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_assign__ = __webpack_require__(659);




var assignedTemplate = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var templatesIds;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						templatesIds = this.dataSelected.map(function (action) {
							return action.id;
						});
						_context.prev = 1;
						_context.next = 4;
						return this.$http.post('distributaries/' + this.id + '/templates', { templatesIds: templatesIds });

					case 4:
						this.showNotification('Los templates fueron asignados correctamente.');
						this.closeModal();
						this.listTemplate();
						_context.next = 12;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function assignedTemplate() {
		return _ref.apply(this, arguments);
	};
}();

var deleteTemplate = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var ids, body;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						ids = this.dataSelectedDeallocate.map(function (item) {
							return item.id;
						});
						body = {
							templatesIds: ids
						};
						_context2.prev = 2;
						_context2.next = 5;
						return this.$http.delete('distributaries/' + this.id + '/templates', { data: body });

					case 5:
						this.showNotification('Template eliminado correctamente');
						this.closeModal();
						this.listTemplateDeallocated();
						_context2.next = 13;
						break;

					case 10:
						_context2.prev = 10;
						_context2.t0 = _context2['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[2, 10]]);
	}));

	return function deleteTemplate() {
		return _ref2.apply(this, arguments);
	};
}();

var listTemplate = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 20,
							isSelected: 0
						};
						_context3.prev = 1;
						_context3.next = 4;
						return this.$http.get('distributaries/' + this.id + '/templates', { params: params });

					case 4:
						response = _context3.sent;

						this.template = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context3.next = 12;
						break;

					case 9:
						_context3.prev = 9;
						_context3.t0 = _context3['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[1, 9]]);
	}));

	return function listTemplate() {
		return _ref3.apply(this, arguments);
	};
}();

var listTemplateDeallocated = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 20,
							isSelected: 1
						};
						_context4.prev = 1;
						_context4.next = 4;
						return this.$http.get('distributaries/' + this.id + '/templates', { params: params });

					case 4:
						response = _context4.sent;

						this.templateAssigned = response.data.data;
						this.lastPageDeallocated = Number(response.headers['x-last-page']);
						_context4.next = 12;
						break;

					case 9:
						_context4.prev = 9;
						_context4.t0 = _context4['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 9]]);
	}));

	return function listTemplateDeallocated() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function disabledAssigned(value) {
	return this.tabsModel === value || this.dataSelected.length < 1;
}

function disabledDeallocated(value) {
	return this.tabsModel === value || this.dataSelectedDeallocate.length < 1;
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.listTemplate();
}

function changePageDeallocate(page) {
	this.params.page = page;
	this.currentPageDeallocate = page;
	this.listTemplateDeallocated();
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function rowIsSelectedDeallocate(row) {
	this.templateAssigned = this.selectIsRow(this.templateAssigned, this.selectedValueAssigned, row);
	this.dataSelectedDeallocate = this.templateAssigned.filter(function (r) {
		return r.flag;
	});
	this.checkAllDeallocate = this.every(this.templateAssigned, this.selectedValueAssigned);
}

function rowIsSelected(row) {
	this.template = this.selectIsRow(this.template, this.selectedValue, row);
	this.dataSelected = this.template.filter(function (r) {
		return r.flagSelected;
	});
	this.checkAll = this.every(this.template, this.selectedValue);
}

function created() {
	this.listTemplate();
	this.listTemplateDeallocated();
}

function onSearchTemplateDeallocate(value) {
	this.params.search = value ? value.trim() : null;
	this.listTemplateDeallocated();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.listTemplate();
}

function allIsSelectedDeallocate(checked) {
	var _this = this;

	this.checkAllDeallocate = checked;
	this.dataSelectedDeallocate = [];
	this.templateAssigned = this.templateAssigned.map(function (element) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newRow.isSelected = checked;
		if (checked) {
			_this.dataSelectedDeallocate.push(element);
		}
		return newRow;
	});
	this.templateAssigned = this.selectIsRow(this.templateAssigned, this.selectedValueAssigned, false, checked);
}

function allIsSelected(checked) {
	var _this2 = this;

	this.checkAll = checked;
	this.dataSelected = [];
	this.template = this.template.map(function (item) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		newRow.isSelected = checked;
		if (checked) {
			_this2.dataSelected.push(item);
		}
		return newRow;
	});
	this.template = this.selectIsRow(this.template, this.selectedValue, false, checked);
}

function data() {
	return {
		checkAllDeallocate: false,
		checkAll: false,
		currentPage: 1,
		currentPageDeallocate: 1,
		dataSelected: [],
		dataSelectedDeallocate: [],
		lastPage: 0,
		lastPageDeallocated: 0,
		selectedValueAssigned: 'flag',
		selectedValue: 'flagSelected',
		template: [],
		templateAssigned: [],
		columns: [{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 2, name: 'Descripción', value: 'description', checked: true, visible: true }],
		tabs: [{
			id: 1,
			name: 'Asignar'
		}, {
			id: 2,
			name: 'Asignados'
		}],
		tabsModel: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-template',
	data: data,
	created: created,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"],
		tableAssign: __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_assign__["a" /* default */]
	},
	methods: {
		allIsSelected: allIsSelected,
		allIsSelectedDeallocate: allIsSelectedDeallocate,
		assignedTemplate: assignedTemplate,
		changePage: changePage,
		changePageDeallocate: changePageDeallocate,
		closeModal: closeModal,
		deleteTemplate: deleteTemplate,
		disabledAssigned: disabledAssigned,
		disabledDeallocated: disabledDeallocated,
		listTemplate: listTemplate,
		listTemplateDeallocated: listTemplateDeallocated,
		rowIsSelectedDeallocate: rowIsSelectedDeallocate,
		onSearchTemplateDeallocate: onSearchTemplateDeallocate,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		id: {
			type: [Number, String]
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/43.70f3d69209112a124c1e.js